var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.wrapClasses, style: _vm.circleSize }, [
    _c("svg", { attrs: { viewBox: "0 0 100 100" } }, [
      _vm.showDefs
        ? _c(
            "defs",
            [
              _c(
                "linearGradient",
                {
                  attrs: {
                    id: _vm.id,
                    x1: "100%",
                    y1: "0%",
                    x2: "0%",
                    y2: "0%"
                  }
                },
                [
                  _c("stop", {
                    attrs: { offset: "0%", "stop-color": _vm.strokeColor[0] }
                  }),
                  _vm._v(" "),
                  _c("stop", {
                    attrs: { offset: "100%", "stop-color": _vm.strokeColor[1] }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("path", {
        style: _vm.trailStyle,
        attrs: {
          d: _vm.pathString,
          stroke: _vm.trailColor,
          "stroke-width": _vm.trailWidth,
          "fill-opacity": 0,
          "stroke-linecap": _vm.strokeLinecap
        }
      }),
      _vm._v(" "),
      _c("path", {
        style: _vm.pathStyle,
        attrs: {
          d: _vm.pathString,
          "stroke-linecap": _vm.strokeLinecap,
          stroke: _vm.strokeValue,
          "stroke-width": _vm.computedStrokeWidth,
          "fill-opacity": "0"
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { class: _vm.innerClasses }, [_vm._t("default")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-13dfef76", { render: render, staticRenderFns: staticRenderFns })
  }
}